var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6175_67108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4987 9.8356L8.24868 4.5856M15.7487 15.8356H5.99868M8.20163 15.1327L14.7031 8.63118C15.5941 7.74014 16.0397 7.29462 16.2066 6.78089C16.3534 6.32899 16.3534 5.84221 16.2066 5.39031C16.0397 4.87657 15.5941 4.43105 14.7031 3.54001L14.5443 3.38118C13.6532 2.49014 13.2077 2.04462 12.694 1.8777C12.2421 1.73087 11.7553 1.73087 11.3034 1.8777C10.7897 2.04462 10.3441 2.49014 9.4531 3.38118L3.29427 9.54001C2.40323 10.4311 1.95771 10.8766 1.79079 11.3903C1.64396 11.8422 1.64396 12.329 1.79079 12.7809C1.95771 13.2946 2.40323 13.7401 3.29427 14.6312L3.79574 15.1327C4.05517 15.3921 4.18488 15.5218 4.33626 15.6146C4.47046 15.6968 4.61678 15.7574 4.76984 15.7942C4.94247 15.8356 5.12591 15.8356 5.4928 15.8356H6.50457C6.87146 15.8356 7.0549 15.8356 7.22753 15.7942C7.38059 15.7574 7.5269 15.6968 7.66111 15.6146C7.81249 15.5218 7.9422 15.3921 8.20163 15.1327Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6175_67108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(-0.000976562 0.0854492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.264165e253822db499d449db3c3c74ab.svg";
export { ForwardRef as ReactComponent };